import React from 'react';
import "./central-panel.css";
import Link from '../../shared/link';
import { t, getCurrentLanguage, getModalContent } from '../../../utils/translations';
import useLanguageStore from '../../../store/languageStore';

class CentralPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLanguage: getCurrentLanguage()
        };
    }

    componentDidMount() {
        // Subscribe to language changes
        this.unsubscribe = useLanguageStore.subscribe((state) => {
            this.setState({ currentLanguage: state.currentLanguage });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        const { currentLanguage } = this.state;
        
        return (
            <div className="central-panel">
                <div className="central-panel-title-group">
                    <h4 className="central-panel-product-name">{t('linha_protheus', currentLanguage)}</h4>
                    <h1 className="central-panel-title">{t('recursos_adicionais', currentLanguage)}</h1>
                </div>
                <div className="central-panel-content">
                    <Link text={t('conheca_centrais', currentLanguage)} link="https://tdn.totvs.com/x/Z9E6Ow" />
                    <Link text={t('avalie_fontes', currentLanguage)} link="https://codeanalysis.totvs.com.br" />
                    <Link text={t('tir_robot', currentLanguage)} link="https://totvs.github.io/tir-docs" />
                    <Link text={t('links_uteis', currentLanguage)} modalContent={getModalContent('links_uteis_modal', currentLanguage)} />
                </div>
            </div>
        );
    }
};

export default CentralPanel;